import angular from 'angular';

import Listing from '../listing/index';
import Config from '../config/index';

import sellerService from './seller.service';

export default angular.module('cars.vdp.shared.seller', [
    Config,
    Listing
])

.factory('sellerService', sellerService)

.name;
